import {
    DatasourceReturnType,
    ResponseError
} from '../../../models/common/respone.model';
import {
    createLineConfig,
    getLineConfig,
    updateLineConfig
} from '../datasources/LineConfig.datasource';
import { LineConfig, ResponseGetLineConfig } from '../schemas/LineConfig.schema';

export async function getLineConfigData(): Promise<DatasourceReturnType<ResponseError, ResponseGetLineConfig>> {
    try {
        const data = (await getLineConfig()).data;
        return [null!, data];
    } catch (error) {
        throw error;
    }
}

export async function updateLineConfigData(body: LineConfig): Promise<DatasourceReturnType<ResponseError, { message: string }>> {
    try {
        const data = (await updateLineConfig(body)).data;
        return [null!, data];
    } catch (error) {
        throw error;
    }
}

export async function createLineConfigData(body: LineConfig): Promise<DatasourceReturnType<ResponseError, { message: string }>> {
    try {
        const data = (await createLineConfig(body)).data;
        return [null!, data];
    } catch (error) {
        throw error;
    }
}
